module.exports = __webpack_public_path__ + "img/icon10@2x.43fa0d57.png";